import { useParams } from "react-router"
import { Box, Button, Icon, ModuleHeaderContainer, ModuleHeaderSlot, Stack, Switch, Tooltip, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useShowCompilationPdf } from "@tm/data/compilations"
import { ArticleList } from "./ArticleList"
import { useListSettings } from "./useListSettings"

type RouteProps = {
    compilationId?: string
    workTaskId: string
}

type Props = {
    compilationId?: string
}

export function SingleFavoriteArticleList(props: Props) {
    const { compilationId } = props
    const matchParams = useParams<RouteProps>()
    const { translateText } = useLocalization()
    const { showCompilationPdf, loadingCompilationPdf } = useShowCompilationPdf(compilationId)
    const { isLoading, compactView, handleChangeCompactView } = useListSettings()

    return (
        <Stack gap={2} flex={1} height="100%" position="relative">
            <ModuleHeaderContainer>
                <Typography variant="h1" pr={2} pb={1}>
                    {translateText(13905)}
                </Typography>
                <ModuleHeaderSlot title={translateText(177)}>
                    <Tooltip title={translateText(49)}>
                        <Box py="1px">
                            <Button
                                disabled={loadingCompilationPdf}
                                onClick={showCompilationPdf}
                                startIcon={<Icon name="print" />}
                                variant="outlined"
                            />
                        </Box>
                    </Tooltip>
                </ModuleHeaderSlot>
                <ModuleHeaderSlot title={translateText(3009)}>
                    {/* Compact View */}
                    <Switch checked={compactView} onChange={handleChangeCompactView} disabled={isLoading} />
                </ModuleHeaderSlot>
            </ModuleHeaderContainer>

            <Box gap={1} p={1} sx={{ minHeight: 0 }}>
                {compilationId ? (
                    <ArticleList
                        compilationId={compilationId}
                        encodedWorkTaskId={matchParams.workTaskId}
                        singleCompilationList
                        onOpenCompilationList={() => {
                            /* do nothing */
                        }}
                    />
                ) : (
                    <Typography variant="body1" className="empty-text">
                        {translateText(1284)}
                    </Typography>
                )}
            </Box>
        </Stack>
    )
}
